/**
 * Pure formatting utilities for Gantt display
 */

const STATUS_EMOJIS = {
	S: "📅", // Scheduled
	I: "🔄", // In Progress
	O: "🔓", // Checked Out
	H: "🔓", // Checked Out (same as O)
	C: "✅", // Complete
	P: "📋", // Complete (By Paper)
	N: "❌", // Incomplete
	T: "⏸️", // Stopped
	X: "🚫", // Cancelled
};

export const getStatusEmoji = (status) => {
	return STATUS_EMOJIS[status] || "❓";
};

export const formatServiceText = (service) => {
	const role = service.role || "Role";
	return role; // Remove emoji from role name
};

const STATUS_NAMES = {
	S: "Scheduled",
	I: "In Progress", 
	O: "Checked Out",
	H: "Checked Out",
	C: "Complete",
	P: "Complete",
	N: "Incomplete",
	T: "Stopped",
	X: "Cancelled",
};

const STATUS_NAME_KEYS = {
	S: "label.scheduled",
	I: "label.inProgress",
	O: "label.checkedOut",
	H: "label.checkedOut",
	C: "action.complete",
	P: "action.complete",
	N: "action.incomplete",
	T: "label.stopped",
	X: "label.cancelled",
};

export const getStatusDisplay = (status, t) => {
	const emoji = getStatusEmoji(status);
	const key = STATUS_NAME_KEYS[status];
	const name = t && key ? t(key) : STATUS_NAMES[status] || "Unknown";
	return `${emoji} ${name}`;
};

export const getStatusColor = (percentageOverTime) => {
	if (percentageOverTime <= 5) {
		return "#23BB79"; // Green - on track
	} else if (percentageOverTime > 5 && percentageOverTime <= 10) {
		return "#ED8738"; // Orange - slightly over
	} else {
		return "#E31212"; // Red - significantly over
	}
};

export const formatWorkOrderText = (workOrderGroup) => {
	const modelInfo = workOrderGroup.modelName && workOrderGroup.model 
		? `${workOrderGroup.modelName} ${workOrderGroup.model}`
		: workOrderGroup.modelName || workOrderGroup.model || "";
	
	const baseText = workOrderGroup.siteAssetName
		? `${workOrderGroup.workOrder} (${workOrderGroup.siteAssetName})`
		: workOrderGroup.workOrder;
	
	return modelInfo ? `${baseText} - ${modelInfo}` : baseText;
};

export const minutesToHours = (minutes) => {
	if (!minutes || minutes === 0) return 0;
	return parseFloat((minutes / 60).toFixed(1));
};

export const normalizeProgress = (progress) => {
	if (!progress) return 0;
	const normalized = progress < 1 && progress > 0 ? progress * 100 : progress;
	return Math.round(Math.max(0, Math.min(100, normalized)));
};